import { cn } from '@/lib/utils';

interface LogoProps {
  size?: number;
  variant?: 'default' | 'mark' | 'inverse';
  className?: string;
}

export function Logo({ size = 28, variant = 'default', className }: LogoProps) {
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src="/logo.png"
        alt="MYND"
        width={size}
        height={size}
        className="object-contain"
        style={{ filter: variant === 'inverse' ? 'brightness(0) invert(1)' : 'none' }}
      />
      {variant !== 'mark' && (
        <span
          className={cn(
            'font-display font-extrabold tracking-tight text-lg',
            variant === 'inverse' ? 'text-white' : 'text-brand-900'
          )}
        >
          MYND<span className="text-brand-500">.</span>
        </span>
      )}
    </div>
  );
}
